<template>
  <div>
    <div class="page-header">
      <div class="page-header-left">
        <ol class="breadcrumb ml-0">
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'welcome' }">
              <feather type="home" />
            </router-link>
          </li>
          <li class="breadcrumb-item">
            <router-link :to="{ name: 'vendorManagementDashboard' }">
              {{ $t('companyFormAdminView.vendorManagement') }}
            </router-link>
          </li>
          <li class="breadcrumb-item">
            {{ $t('vendorManagementBlacklist.qaraSiyah') }}
          </li>
        </ol>
      </div>
      <h4 class="my-3">
        {{ $t('vendorManagementBlacklist.qaraSiyah') }}
      </h4>

      <div class="mb-3">
        {{ $t('vendorManagementBlacklist.sizIrktinizinQaydalarnaUyunHrHansBirTkilatQaraSiya') }}
      </div>
    </div>


    <div class="card ">
      <div class="card-body">
        <table class="table table-striped">
          <thead>
            <tr>
              <th>{{ $t('companyProfile.ven') }}</th>
              <th>{{ $t('companyPage.irkt') }}</th>
              <th>{{ $t('request.sbb') }}</th>
              <th>-</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="b in blackList">
              <td>
                {{ b.taxId }}
              </td>
              <td>
                <span v-if="b.blacklistedCompanyName"> {{ b.blacklistedCompanyName }}</span>
                <span
                  v-else
                  style="color: #b6b6b6"
                >{{ $t('vendorManagementBlacklist.hazirdaSistemdMvcudDeyil') }}</span>
              </td>
              <td>{{ b.reason }}</td>
              <td>
                <a
                  href="#"
                  class="mr-3"
                  @click.prevent="editBlacklist(b.id, b.reason)"
                >
                  <feather
                    type="edit-3"
                    class="text-primary"
                  />
                </a>
                <a
                  href="#"
                  @click.prevent="deleteBlacklist(b.taxId)"
                >
                  <feather
                    type="trash"
                    class="text-danger"
                  />
                </a>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="my-3">
          <button
            v-b-modal.modal_blacklist_create
            class="btn btn-sm btn-dark"
          >
            {{ $t('vendorManagementBlacklist.lavEt') }}
          </button>
        </div>
      </div>
    </div>


    <b-modal
      id="modal_blacklist_create"
      centered
      :title="$t('vendorManagementBlacklist.qaraSiyahyaIrktLavEt')"
      class="theme-modal"
      :hide-footer="true"
    >
      <form @submit.prevent="addBlacklist">
        <div class="mb-3">
          <label>{{ $t('companyProfile.ven') }}</label>
          <div>
            <input
              v-model.trim.number="newBlacklist.taxId"
              type="number"
              class="form-control"
              required
            >
          </div>
        </div>


        <div class="mb-3">
          <label>{{ $t('request.sbb') }} </label>
          <div>
            <textarea
              v-model.trim="newBlacklist.reason"
              type="text"
              class="form-control"
              required
            />
          </div>
        </div>

        <div class="mb-3">
          <button
            type="submit"
            class="btn btn-success"
          >
            {{ $t('request.lavEt') }}
          </button>
        </div>
      </form>
    </b-modal>
  </div>
</template>
<script>
import {mapState} from "vuex";
import {mediaBase} from "@/repositories/Repository";
import {
  addBlacklist,
  getBlacklist,
  handleErrors,
  removeBlacklist, updateBlacklist
} from "@/repositories/VendorManagementRepository";

import {getCompanyFormat} from "@/repositories/Utils";

export default {
  components: {},
  data() {
    return {
      mediaBase: mediaBase,
      blackList: [],

      newBlacklist: {
        taxId: '',
        reason: ''
      },

    }
  },
  computed: {
    ...mapState({
      token: state => state.auth.token,
      user: state => state.auth.user,
    }),


  },
  mounted() {

    this.getBlacklistData();


  },
  methods: {


    getCompanyFormat(keyword) {
      return getCompanyFormat(keyword, this.$i18n.locale);
    },
    getBlacklistData() {

      getBlacklist(this.token).then(list => {
        this.blackList = list;
      })

    },

    addBlacklist() {

      addBlacklist(this.token, this.newBlacklist.taxId, this.newBlacklist.reason,).then(data => {
        if (data.code === 200) {
          this.getBlacklistData();
          this.$swal({
            title: this.$t("generalModal.successTitle"),
            text: data.companyRegistered ? this.$t("elvaEdld") : this.$t("buVOENSyhyElvEdldLknbVnHzrd"),
            icon: 'success'
          });

          this.newBlacklist.taxId = '';
          this.newBlacklist.reason = '';

          this.$bvModal.hide('modal_blacklist_create');

        } else if (data.code === 409) {
          this.$swal({
            title: this.$t("generalModal.warningTitle"),
            text: this.$t("buShrtArtqElvEdlb"),
            icon: 'warning'
          });

        } else {
          handleErrors(this.$swal, data, null);
        }
      })

    },

    deleteBlacklist(taxId) {

      this.$swal({
        title: this.$t("general.dltConfirm"),
        text: this.$t("buSrktArtqSznSrktnzPrtl"),
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t("general.delete"),
        cancelButtonText: this.$t("companyProfile.lvEt2")

      }).then((result) => {

        if (result.value) {
          removeBlacklist(this.token, taxId).then(data => {
            if (data.code === 200) {
              this.getBlacklistData();
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("generalModal.deleted"),
                icon: 'success'
              });

            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }

      })

    },

    editBlacklist(id, reason) {
      this.$swal({
        title: this.$t("sbbQydEdn"),
        icon: 'question',
        input: 'textarea',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t("sectorSelectionModal.yaddaSaxla"),
        cancelButtonText: this.$t("companyProfile.lvEt2"),
        inputValue: reason

      }).then((result) => {

        if (result.value) {
          updateBlacklist(this.token, id, result.value).then(data => {
            if (data.code === 200) {
              this.getBlacklistData();
              this.$swal({
                title: this.$t("generalModal.successTitle"),
                text: this.$t("sbbYnlnd"),
                icon: 'success'
              });

            } else {
              handleErrors(this.$swal, data, null);
            }
          })
        }
      })
    },
  }
}
</script>
<style>
div.review canvas {
  position: relative !important;
}

div.review input {
  z-index: 1;
  display: inline-block;
}
</style>
